import { TODO } from "../actions/utilities";
import { TODO_SORT_TYPE } from "../../config";
import { IntegerToTimeString } from "../../assets";

const INITIAL_STATE = {
  userTodosData: [],
  userTodosDataLoading: false,
  userTodosDataSuccess: false,
  userTodosDataError: null,

  getToDoEmployeesLoading: false,
  getToDoEmployeesSuccess: false,
  getToDoEmployeesFailure: false,
  getToDoEmployeesError: null,

  getAllHomeUserTodoLoading: false,
  getAllHomeUserTodoSuccess: false,
  getAllHomeUserTodoFailure: false,
  getAllHomeUserTodoError: null,
  getAllHomeUserTodoData: [],

  getToDoLoading: false,
  getToDoLoadingForEmployeeId: 0,
  getToDoSuccess: false,
  getToDoFailure: false,
  getToDoError: null,

  addToDoLoading: false,
  addToDoSuccess: false,
  addToDoFailure: false,
  addToDoError: null,
  editToDoLoading: false,
  editToDoSuccess: false,
  editToDoFailure: false,
  editToDoError: null,
  deleteToDoLoading: false,
  deleteTodoSuccess: false,
  deleteTodoFailure: false,
  deleteTodoError: null,
  completeTodoSuccess: false,
  completeToDoLoading: false,
  completeTodoFailure: false,
  completeTodoError: null,

  postTodocommentSuccess: false,
  postTodocommentLoading: false,
  postTodocommentFailure: false,
  postTodocommentError: null,

  getTodocommentSuccess: false,
  getTodocommentLoading: false,
  getTodocommentFailure: false,
  getTodocommentError: null,

  deleteTodocommentSuccess: false,
  deleteTodocommentLoading: false,
  deleteTodocommentFailure: false,
  deleteTodocommentError: null,

  isMyToDo: false, // handelling sir irfan's case

  ToDoUsers: [],
  FilteredToDoUsers: [],

  sortType: TODO_SORT_TYPE.ATTENDANCE,

  loadWorkProgressSuccess: false,
  loadWorkProgressLoading: false,
  loadWorkProgressFailure: false,
  loadWorkProgressError: null,
  workProgressData: null,

  addTodoFlagSuccess: false,
  addTodoFlagLoading: false,
  addTodoFlagFailure: false,
  addTodoFlagError: null,

  addTodoLogTimeSuccess: false,
  addTodoLogTimeLoading: false,
  addTodoLogTimeFailure: false,
  addTodoLogTimeError: null,

  getLoggedHourGraphDataSuccess: false,
  getLoggedHourGraphDataLoading: false,
  getLoggedHourGraphDataFailure: false,
  getLoggedHourGraphDataError: null,
  loggedHourGraphData: null,

  getTaskHourComparisonByEmpSuccess: false,
  getTaskHourComparisonByEmpLoading: false,
  getTaskHourComparisonByEmpFailure: false,
  getTaskHourComparisonByEmpError: null,
  taskHourComparisonByEmp: null,

  getEmpRankingOnLoggedHoursSuccess: false,
  getEmpRankingOnLoggedHoursLoading: false,
  getEmpRankingOnLoggedHoursFailure: false,
  getEmpRankingOnLoggedHoursError: null,
  empRankingOnLoggedHours: [],

  getEmpTasksGraphSuccess: false,
  getEmpTasksGraphLoading: false,
  getEmpTasksGraphFailure: false,
  getEmpTasksGraphError: null,
  empTasksGraph: [],

  getEmpTodoTaskListSuccess: false,
  getEmpTodoTaskListLoading: false,
  getEmpTodoTaskListFailure: false,
  getEmpTodoTaskListError: null,
  empTodoTaskList: [],

  todoEmployees: [],
  employeeTodos: [],
  comments: [],
};

export const toDoReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TODO.CLEAR_TODO_EMPLOYEES:
      state.todoEmployees = [];
      return {
        ...state,
      };
    case TODO.GET_TODO_EMPLOYEES_REQUEST:
      return {
        ...state,
        getToDoEmployeesLoading: true,
        getToDoEmployeesSuccess: false,
        getToDoEmployeesFailure: false,
        getToDoEmployeesError: null,
      };
    case TODO.GET_TODO_EMPLOYEES_FAILURE:
      return {
        ...state,
        getToDoEmployeesLoading: false,
        getToDoEmployeesSuccess: false,
        getToDoEmployeesFailure: true,
        getToDoEmployeesError: action.payload,
      };
    case TODO.GET_TODO_EMPLOYEES_SUCCESS:
      if (action.info.pageNo == 1) {
        state.todoEmployees = [];
      }
      if (action.payload && action.payload.length > 0) {
        var todoEmps = state.todoEmployees;
        for (var i = 0; i < action.payload.length; i++) {
          todoEmps.push(action.payload[i]);
        }
        state.todoEmployees = todoEmps;
      }
      return {
        ...state,
        getToDoEmployeesLoading: false,
        getToDoEmployeesSuccess: true,
        getToDoEmployeesFailure: false,
        getToDoEmployeesError: null,
      };

    case TODO.SET_TEAM_MEMBER_ID:
      state.SelectedTeamMemberId = action.payload;
      // console.log("reducer => SelectedTeamMemberId", action.payload);
      return {
        ...state,
      };
    case TODO.FILL_DATA_STORE_USERS:
      state.TodoUsersDataStorage = action.payload;
      return {
        ...state,
      };

    case TODO.POPULATE_USERS_TODOLISTS:
      var todoLists = action.payload;
      var todoUsers = state.TodoUsersDataStorage;
      state.TeamLeads = [];
      state.TeamMembers = [];
      if (todoUsers && todoUsers.length > 0) {
        for (let i = 0; i < todoUsers.length; i++) {
          var lists = todoLists.filter((l) => l.userId == todoUsers[i].userId);
          todoUsers[i].toDoLists = lists;

          if (todoUsers[i].isTeamLead === true) {
            state.TeamLeads.push({
              value: todoUsers[i].userId,
              text: todoUsers[i].username,
            });
          }
          state.TeamMembers.push({
            value: todoUsers[i].userId,
            text: todoUsers[i].username,
          });
          state.EmployeesDDList.push({
            userId: todoUsers[i].userId,
            employeeName: todoUsers[i].username,
          });
        }
      }
      state.ToDoUsers = todoUsers;
      state.FilteredToDoUsers = todoUsers;

      return {
        ...state,
      };
    case TODO.GET_TEAM_MEMBERS:
      var loadAllUsers = false;
      var receivedObject = action.payload;

      if (receivedObject) {
        if (receivedObject.teamLeadId > 0) {
          state.SelectedTeamLeadId = receivedObject.teamLeadId;
          state.TeamMembers = [];
          state.FilteredToDoUsers = [];
          var todoUsers = state.ToDoUsers;
          if (todoUsers && todoUsers.length > 0) {
            for (let i = 0; i < todoUsers.length; i++) {
              if (todoUsers[i].teamLeadId == receivedObject.teamLeadId) {
                state.TeamMembers.push({
                  value: todoUsers[i].userId,
                  text: todoUsers[i].username,
                });
                // console.log("reducer => selectec user", todoUsers[i]);
                state.FilteredToDoUsers.push(todoUsers[i]);
              }
            }
          }
        } else {
          loadAllUsers = true;
          state.SelectedTeamLeadId = 0;
        }
      } else {
        state.SelectedTeamLeadId = 0;
        loadAllUsers = true;
      }
      if (loadAllUsers === true) {
        state.TeamMembers = [];
        for (let i = 0; i < state.ToDoUsers.length; i++) {
          state.TeamMembers.push({
            value: state.ToDoUsers[i].userId,
            text: state.ToDoUsers[i].username,
          });
        }
        state.FilteredToDoUsers = state.ToDoUsers;
      }
      return {
        ...state,
      };
    case TODO.GET_EMPLOYEES_REQUEST:
      return {
        ...state,
        getEmployeesLoading: true,
        getEmployeesSuccess: false,
        getEmployeesFailure: false,
        getEmployeesError: null,
      };
    case TODO.GET_EMPLOYEES_SUCCESS:
      return {
        ...state,
        getEmployeesLoading: false,
        getEmployeesSuccess: true,
        getEmployeesFailure: false,
        getEmployeesError: null,
        ToDoUsers: action.payload,
      };
    case TODO.GET_EMPLOYEES_FAILURE:
      return {
        ...state,
        getEmployeesLoading: false,
        getEmployeesSuccess: false,
        getEmployeesFailure: true,
        getEmployeesError: null,
        ToDoUsers: null,
      };

    case TODO.GET_TODO_REQUEST:
      return {
        ...state,
        getToDoLoading: true,
        getToDoLoadingForEmployeeId: action.payload,
        getToDoSuccess: false,
        getToDoFailure: false,
        getToDoError: null,
        getToDoError: null,
      };
    case TODO.GET_TODO_SUCCESS:
      var rcvdObj = action.payload;
      if (rcvdObj) {
        var emps = state.todoEmployees;
        let selectedEmp = emps.filter((e) => e.userId == rcvdObj[0].employeeId);
        if (selectedEmp && selectedEmp.length > 0) {
          selectedEmp = selectedEmp[0];
          selectedEmp.employeeTodos = rcvdObj;
          // console.log("reducer => selectedUser", selectedEmp);

          //new list in task view (day planner)
          // let newList = [];
          // for (let i = 0; i < rcvdObj.length; i++) {
          //     if (rcvdObj[i].todos !== null) {
          //         for (let j = 0; j < rcvdObj[i].todos.length; j++) {
          //             let singleTask = rcvdObj[i].todos[j];
          //             singleTask = {
          //                 ...singleTask,
          //                 categoryName: rcvdObj[i].categoryName,
          //                 categoryId: rcvdObj[i].taskCategoryId
          //             };
          //             newList.push(singleTask);
          //         }
          //     }
          // }

          // selectedEmp.employeeTodosNew = newList;
          //new list in task view (day planner)
        }
      }
      // let selectedEmp = []
      // if (rcvdObj) {
      //
      //     var emps = [...state.todoEmployees]
      //     selectedEmp = emps.filter((e) => e.userId == rcvdObj[0].employeeId);
      //     if (selectedEmp && selectedEmp.length > 0) {
      //         selectedEmp = selectedEmp[0];
      //         selectedEmp = { ...selectedEmp, employeeTodos: rcvdObj }
      //         console.log("reducer => selectedUser", selectedEmp);
      //     }
      // }
      return {
        ...state,
        getToDoLoading: false,
        getToDoSuccess: true,
        getToDoLoadingForEmployeeId: 0,
        getToDoFailure: false,
        getToDoError: null,
        // todoEmployees: selectedEmp
        //ToDoUsers: action.payload
      };
    case TODO.GET_TODO_FAILURE:
      return {
        ...state,
        getToDoLoading: false,
        getToDoSuccess: false,
        getToDoLoadingForEmployeeId: 0,
        getToDoFailure: true,
        getToDoError: action.payload,
      };

    case TODO.ADD_TODO_REQUEST:
      return {
        ...state,
        addToDoLoading: true,
        addToDoSuccess: false,
        addToDoFailure: false,
        addToDoError: null,
      };
    case TODO.ADD_TODO_SUCCESS:
      var receivedObj = action.payload;
      // console.log("reducer => receivedObj-addtodo", receivedObj);
      var emps = state.todoEmployees;
      if (emps && emps.length > 0) {
        var userObj = emps.filter((u) => u.userId === receivedObj.assigneeId);
        if (userObj && userObj.length > 0) {
          const timeArray = receivedObj.dueDate.split("T");
          var ts = new Date();
          ts = ts.toISOString().split("T");
          // console.log(timeArray[0], ts[0]);
          if (timeArray[0] == ts[0]) {
            var todayHours = userObj[0].todayHours; // hours
            var newEstimatedTime = receivedObj.estimatedTime / 60;
            todayHours = todayHours + newEstimatedTime;
            userObj[0].todayHours = parseFloat(todayHours);
            userObj[0].todayTasksCount = userObj[0].todayTasksCount + 1;
          }
          if (userObj[0].employeeTodos && userObj[0].employeeTodos.length > 0) {
            var requiredList = userObj[0].employeeTodos.filter(
              (l) => l.taskCategoryId == receivedObj.taskCategoryId
            );
            // console.log(requiredList, "requiredList");
            if (requiredList && requiredList.length > 0) {
              if (requiredList && requiredList.length > 0) {
                if (!requiredList[0].todos) {
                  requiredList[0].todos = [];
                }
                requiredList[0].todos.unshift(receivedObj);
                requiredList[0].totalTasksInCategory =
                  requiredList[0].todos.length;
              }
            }
          }
        }
      }
      return {
        ...state,
        addToDoLoading: false,
        addToDoSuccess: true,
        addToDoFailure: false,
        addToDoError: null,
      };
    case TODO.ADD_TODO_FAILURE:
      // console.log(action.payload);
      return {
        ...state,
        addToDoLoading: false,
        addToDoSuccess: false,
        addToDoFailure: true,
        addToDoError: action.payload,
      };
    case TODO.EDIT_TODO_REQUEST:
      return {
        ...state,
        editToDoLoading: true,
        editToDoSuccess: false,
        editToDoFailure: false,
        editToDoError: null,
      };
    case TODO.EDIT_TODO_SUCCESS:
      var receivedObj = action.payload;
      var empsFound = state.todoEmployees.filter(
        (e) => e.userId == receivedObj.assigneeId
      );
      if (empsFound && empsFound.length > 0) {
        if (empsFound[0].employeeTodos) {
          // var requiredTaskList = empsFound[0].employeeTodos.filter(
          //     (l) => l.taskCategoryId == receivedObj.taskCategoryId
          //     //(l) => l.taskCategoryId == action.info
          // );

          let requiredTaskList = [];
          for (let i = 0; i < empsFound[0].employeeTodos.length; i++) {
            let taskList = [];
            taskList = empsFound[0]?.employeeTodos[i]?.todos?.filter(
              (item) => item.taskId === receivedObj.taskId
            );
            if (taskList !== undefined && taskList.length > 0) {
              requiredTaskList.push(empsFound[0].employeeTodos[i]);
              break;
            }
          }

          if (requiredTaskList && requiredTaskList.length > 0) {
            if (!requiredTaskList[0].todos) {
              requiredTaskList[0].todos = [];
            }
            var existingTodo = requiredTaskList[0].todos.filter(
              (t) => t.taskId == receivedObj.taskId
            );
            if (!existingTodo || existingTodo.length <= 0) {
              requiredTaskList[0].todos.push(receivedObj);
            } else if (existingTodo && existingTodo.length > 0) {
              existingTodo = existingTodo[0];
              var todayHours = empsFound[0].todayHours; // hours
              var exsEstimatedTime = existingTodo.estimatedTime / 60;
              todayHours =
                todayHours -
                exsEstimatedTime +
                parseFloat(receivedObj.estimatedTime / 60);
              empsFound[0].todayHours = parseFloat(todayHours);
              // populating object props
              existingTodo.title = receivedObj.title;
              existingTodo.taskCategoryId = receivedObj.taskCategoryId;
              existingTodo.taskCategory = receivedObj.taskCategory;
              existingTodo.description = receivedObj.description;
              existingTodo.dueDate = receivedObj.dueDate;
              existingTodo.estimatedTime = receivedObj.estimatedTime;
              existingTodo.repeatType = receivedObj.repeatType;
              existingTodo.reportedByName = receivedObj.reportedByName;
              existingTodo.severity = receivedObj.severity;
              existingTodo.severityId = receivedObj.severityId;
              existingTodo.taskListId = receivedObj.taskListId;
              existingTodo.projectId = receivedObj.projectId;
            }
          }
        }
      }
      return {
        ...state,
        editToDoLoading: false,
        editToDoSuccess: true,
        editToDoFailure: false,
        editToDoError: null,
        //  ToDoList: addtodo,
      };
    case TODO.EDIT_TODO_FAILURE:
      return {
        ...state,
        editToDoLoading: false,
        editToDoSuccess: false,
        editToDoFailure: true,
        editToDoError: action.payload,
      };
    case TODO.DELETE_TODO_REQUEST:
      return {
        ...state,
        deleteToDoLoading: true,
        deleteToDoSuccess: false,
        deleteToDoFailure: false,
        deleteToDoError: null,
      };
    case TODO.DELETE_TODO_SUCCESS:
      // debugger;
      var infoObj = action.info;
      var emp = state.empTodoTaskList.filter(
        (e) => e.taskId !== infoObj.taskId
      );

      // if (emp) {
      //   var list = emp[0].empTodoTaskList.filter(
      //     (td) => td.taskCategoryId == infoObj.listId
      //   );
      //   if (list && list.length > 0) {
      //     // deducting deleted todo hours from total hours
      //     var existingTodo = list[0].todos.filter(
      //       (t) => t.taskId == infoObj.taskId
      //     );
      //     if (existingTodo && existingTodo.length > 0) {
      //       var duedate = new Date(existingTodo[0].dueDate).toDateString();
      //       // console.log('reducer due date', +new Date(duedate));
      //       // console.log('reducer new date', +new Date(new Date().toDateString()));

      //       // if date is same, then reduce time and progress. else no effect on progoress bar,
      //       // because progress bar show today progress only.
      //       existingTodo = existingTodo[0];
      //       if (+new Date(duedate) == +new Date(new Date().toDateString())) {
      //         var todayHours = parseFloat(emp[0].todayHours); // hours
      //         var exsEstimatedTime = parseFloat(
      //           existingTodo.estimatedTime / 60
      //         );
      //         todayHours = todayHours - exsEstimatedTime;
      //         emp[0].todayHours = parseFloat(todayHours);
      //       }
      //       emp[0].todayTasksCount = emp[0].todayTasksCount - 1;
      //       if (existingTodo.completedDate !== null) {
      //         list[0].completedTasksInCategory =
      //           list[0].completedTasksInCategory - 1;
      //       }
      //       //////////
      //       var newTodos = list[0].todos.filter(
      //         (td) => td.taskId != infoObj.taskId
      //       );
      //       list[0].todos = newTodos;
      //       list[0].totalTasksInCategory = list[0].todos.length;
      //     }
      //   }
      // }
      return {
        ...state,
        deleteToDoLoading: false,
        deleteToDoSuccess: true,
        deleteToDoFailure: false,
        deleteToDoError: null,
        empTodoTaskList: emp,
      };
    case TODO.DELETE_TODO_FAILURE:
      return {
        ...state,
        deleteToDoLoading: false,
        deleteToDoSuccess: false,
        deleteToDoFailure: true,
        deleteToDoError: action.payload,
      };
    case TODO.COMPLETE_TODO_REQUEST:
      return {
        ...state,
        completeToDoLoading: true,
        completeToDoSuccess: false,
        completeToDoFailure: false,
        completeToDoError: null,
      };
    case TODO.COMPLETE_TODO_SUCCESS: {
      const infoObj = action.info;
      // Use a guard to avoid errors if todoEmployees is somehow undefined
      const todoEmployees = state.todoEmployees || [];
      const emp = todoEmployees.filter((e) => e.userId === infoObj.employeeId);
      if (emp.length > 0) {
        const employeeTodos = emp[0].employeeTodos || [];
        const list = employeeTodos.filter(
          (td) => td.taskCategoryId === infoObj.listId
        );
        if (list.length > 0) {
          const currDate = new Date().setHours(0, 0, 0, 0);
          const dueDate = new Date(infoObj.dueDate).setHours(0, 0, 0, 0);
          const todos = list[0].todos || [];
          const requiredTodo = todos.filter(
            (td) => td.taskId === infoObj.taskId
          );
          if (requiredTodo.length > 0) {
            if (infoObj.status) {
              if (currDate === dueDate) {
                requiredTodo[0].completedDate = new Date();
                list[0].completedTasksInCategory =
                  (list[0].completedTasksInCategory || 0) + 1;
              } else {
                const newTodos = todos.filter(
                  (td) => td.taskId !== infoObj.taskId
                );
                list[0].todos = newTodos;
                list[0].totalTasksInCategory = newTodos.length;
              }
            } else {
              requiredTodo[0].completedDate = null;
              list[0].completedTasksInCategory =
                (list[0].completedTasksInCategory || 1) - 1;
            }
          }
        }
      }
      return {
        ...state,
        completeToDoLoading: false,
        completeToDoSuccess: true,
        completeToDoFailure: false,
        completeToDoError: null,
      };
    }

    case TODO.COMPLETE_TODO_FAILURE:
      return {
        ...state,
        completeToDoLoading: false,
        completeToDoSuccess: false,
        completeToDoFailure: true,
        completeToDoError: action.payload,
      };

    case TODO.GET_ALL_HOME_USER_TODO_REQUEST:
      return {
        ...state,
        getAllHomeUserTodoLoading: true,
        getAllHomeUserTodoSuccess: false,
        getAllHomeUserTodoFailure: false,
        getAllHomeUserTodoError: null,
      };
    case TODO.GET_ALL_HOME_USER_TODO_SUCCESS:
      return {
        ...state,
        getAllHomeUserTodoLoading: false,
        getAllHomeUserTodoSuccess: true,
        getAllHomeUserTodoFailure: false,
        getAllHomeUserTodoError: null,
        getAllHomeUserTodoData: action.payload,
      };
    case TODO.GET_ALL_HOME_USER_TODO_FAILURE:
      return {
        ...state,
        getAllHomeUserTodoLoading: false,
        getAllHomeUserTodoSuccess: false,
        getAllHomeUserTodoFailure: true,
        getAllHomeUserTodoError: action.payload,
      };

    case TODO.POST_TODO_COMMENT_REQUEST:
      return {
        ...state,
        postTodocommentSuccess: false,
        postTodocommentLoading: true,
        postTodocommentFailure: false,
        postTodocommentError: null,
      };

    case TODO.POST_TODO_COMMENT_SUCCESS:
      // debugger;
      var indexInfo = action.info;
      var receivedObj = action.payload;

      // var task =
      //   state.empTodoTaskList[indexInfo.empIndex]?.employeeTodos[
      //     indexInfo.listIndex
      //   ].todos[indexInfo.taskIndex];
      var task = state.empTodoTaskList[indexInfo.empIndex];
      if (receivedObj.parentId && receivedObj.parentId > 0) {
        // debugger;
        var replies = task?.comments[indexInfo.commentIndex]?.replies;
        if (replies === null) {
          replies = [];
        }
        // console.log("reducer => replies", replies);
        if (receivedObj.commentId && receivedObj.commentId > 0) {
          var findReply = replies?.filter(
            (r) => r.commentId == receivedObj.commentId
          );
          if (findReply && findReply.length > 0) {
            replies[indexInfo.replyIndex] = receivedObj;
          } else {
            replies?.push(receivedObj);
          }
        } else {
          replies?.push(receivedObj);
        }
        task.comments[indexInfo.commentIndex].replies = replies;
      } else {
        var comments = task?.comments;
        if (comments === null) {
          comments = [];
        }
        var findComment = task?.comments?.filter(
          (r) => r.commentId == receivedObj.commentId
        );
        if (findComment && findComment.length > 0) {
          comments[indexInfo.commentIndex] = receivedObj;
        } else {
          comments?.push(receivedObj);
        }
        task.comments = comments;
      }

      return {
        ...state,
        postTodocommentSuccess: true,
        postTodocommentLoading: false,
        postTodocommentFailure: false,
        postTodocommentError: null,
      };

    case TODO.POST_TODO_COMMENT_FAILURE:
      return {
        ...state,
        postTodocommentSuccess: false,
        postTodocommentLoading: false,
        postTodocommentFailure: true,
        postTodocommentError: action.payload,
      };

    case TODO.GET_TODO_COMMENT_REQUEST:
      return {
        ...state,
        getTodocommentSuccess: false,
        getTodocommentLoading: true,
        getTodocommentFailure: false,
        getTodocommentError: null,
      };

    case TODO.GET_TODO_COMMENT_SUCCESS:
      var indexInfo = action.info;
      var task =
        state.todoEmployees[indexInfo.empIndex].employeeTodos[
          indexInfo.listIndex
        ].todos[indexInfo.taskIndex];
      task.comments = action.payload;
      return {
        ...state,
        getTodocommentSuccess: true,
        getTodocommentLoading: false,
        getTodocommentFailure: false,
        getTodocommentError: null,
      };

    case TODO.GET_TODO_COMMENT_FAILURE:
      return {
        ...state,
        getTodocommentSuccess: false,
        getTodocommentLoading: false,
        getTodocommentFailure: true,
        getTodocommentError: action.payload,
      };

    case TODO.DELETE_TODO_COMMENT_REQUEST:
      return {
        ...state,
        deleteTodocommentSuccess: false,
        deleteTodocommentLoading: true,
        deleteTodocommentFailure: false,
        deleteTodocommentError: null,
      };

    case TODO.DELETE_TODO_COMMENT_SUCCESS:
      var indexInfo = action.info;
      // console.log("Hit =>  indexinfo", indexInfo);
      // var task =
      //   state.todoEmployees[indexInfo.empIndex]?.employeeTodos[
      //     indexInfo.listIndex
      //   ].todos[indexInfo.taskIndex];
      var task = state.empTodoTaskList[indexInfo.empIndex];
      var newComments = task?.comments;
      if (!newComments) {
        newComments = [];
      }
      if (indexInfo.replyIndex != null) {
        var replies = newComments[indexInfo.commentIndex].replies;
        replies.splice(indexInfo.replyIndex, 1);
        newComments[indexInfo.commentIndex].replies = replies;
        //newComments = newComments[indexInfo.commentIndex].replies.filter(r => r.commentId != receivedObj.commentId);
      } else {
        newComments.splice(indexInfo.commentIndex, 1);
        //newComments = newComments.filter(c => c.commentId != receivedObj.commentId);
      }
      task.comments = newComments;
      return {
        ...state,
        deleteTodocommentSuccess: true,
        deleteTodocommentLoading: false,
        deleteTodocommentFailure: false,
        deleteTodocommentError: null,
      };

    case TODO.DELETE_TODO_COMMENT_FAILURE:
      return {
        ...state,
        deleteTodocommentSuccess: false,
        deleteTodocommentLoading: false,
        deleteTodocommentFailure: true,
        deleteTodocommentError: action.payload,
      };

    case TODO.IS_MY_TODOS_TRUE:
      return {
        isMyToDo: true,
      };

    case TODO.IS_MY_TODOS_FALSE:
      return {
        isMyToDo: false,
      };

    case TODO.TODO_MESSAGES_RESET:
      return {
        ...state,
        completeToDoLoading: false,
        completeToDoSuccess: false,
        completeToDoFailure: false,
        completeToDoError: null,
        //--------------------------
        deleteToDoLoading: false,
        deleteToDoSuccess: false,
        deleteToDoFailure: false,
        deleteToDoError: null,
        //-----------------------
        editToDoLoading: false,
        editToDoSuccess: false,
        editToDoFailure: false,
        editToDoError: null,
        //-----------------------
        addToDoLoading: false,
        addToDoSuccess: false,
        addToDoFailure: false,
        addToDoError: null,
        //-----------------------
        postTodocommentSuccess: false,
        postTodocommentLoading: false,
        postTodocommentFailure: false,
        postTodocommentError: null,
      };

    case TODO.TODO_SORT_TYPE:
      // var todoList = state.ToDoList;
      // if (todoList && todoList.toDoUsers && todoList.toDoUsers.length > 0) {
      //     for (let i = 0; i < todoList.toDoUsers.length; i++) {
      //         let userObj = todoList.toDoUsers[i];
      //         if (userObj.toDoLists) {
      //             for (let j = 0; j < userObj.toDoLists.length; j++) {
      //                 var list = userObj.toDoLists[j];
      //                 if (list && list.toDos && list.toDos.length > 0) {
      //                     list.toDos.filter(t => t.toDoId === receivedObj.toDoId);
      //                     if (requiredTodo && requiredTodo.length > 0) {
      //                         let objComment =
      //                         {
      //                             "toDoCommentId": receivedObj.toDoCommentId,
      //                             "comment": receivedObj.comment,
      //                             "createdDate": receivedObj.createdDate,
      //                             "username": receivedObj.createdByName,
      //                             "profilePicture": receivedObj.profilePicture,
      //                             "toDosReplies": null
      //                         };
      //                         if (receivedObj.parentId > 0) {
      //                             let parentComment = requiredTodo[0].toDosComments.filter(c => c.toDoCommentId === receivedObj.parentId);
      //                             if (parentComment && parentComment.length > 0) {
      //                                 if (parentComment[0].toDosReplies) {
      //                                     parentComment[0].toDosReplies.push(objComment);
      //                                 }
      //                                 else {
      //                                     parentComment[0].toDosReplies = [];
      //                                     parentComment[0].toDosReplies.push(objComment);
      //                                 }
      //                             }
      //                         }
      //                         else {
      //                             requiredTodo[0].toDosComments.push(objComment);
      //                         }
      //                         todoFound = true;
      //                         break;
      //                     }
      //                 }
      //             }
      //         }
      //     }
      // }
      // if (sortingOrder === TODO_SORTING_ORDER.HIGHT_TO_LOW) {

      // }
      // else {

      // }
      return {
        ...state,
      };

    case TODO.LOAD_WORK_PROGRESS_REQUEST:
      return {
        ...state,
        loadWorkProgressLoading: true,
        loadWorkProgressSuccess: false,
        loadWorkProgressFailure: false,
        loadWorkProgressError: null,
        workProgressData: null,
      };
    case TODO.LOAD_WORK_PROGRESS_SUCCESS:
      return {
        ...state,
        loadWorkProgressLoading: false,
        loadWorkProgressSuccess: true,
        loadWorkProgressFailure: false,
        loadWorkProgressError: null,
        workProgressData: action.payload,
      };
    case TODO.LOAD_WORK_PROGRESS_FAILURE:
      return {
        ...state,
        loadWorkProgressLoading: false,
        loadWorkProgressSuccess: false,
        loadWorkProgressFailure: true,
        loadWorkProgressError: action.payload,
        workProgressData: null,
      };
    case TODO.ADD_TODO_FLAG_REQUEST:
      return {
        ...state,
        addTodoFlagLoading: true,
        addTodoFlagSuccess: false,
        addTodoFlagFailure: false,
        addTodoFlagError: null,
      };
    case TODO.ADD_TODO_FLAG_SUCCESS:
      var receivedObj = action.payload;
      var info = action.info;
      // console.log("reducer => receivedObj-flag", receivedObj);
      var emps = state.todoEmployees.filter((e) => e.userId == info.employeeId);
      if (emps && emps.length > 0) {
        var emp = emps[0];
        var flagsCount = parseInt(emp.flagsCount);
        emp.flagsCount = flagsCount + 1;
        let updatedFlagLogs = emp.flagLogs;
        if (updatedFlagLogs === null) {
          updatedFlagLogs = [];
        }
        updatedFlagLogs.push(action.payload);
        emp.flagLogs = updatedFlagLogs;
      }
      if (action.payload.taskId !== null) {
        let listIndex = emp.employeeTodos.findIndex(
          (item) => item.taskCategoryId === action.info.taskCategoryId
        );
        let taskIndex = emp.employeeTodos[listIndex].todos.findIndex(
          (item) => item.taskId === action.info.taskId
        );
        let flagLog = [
          {
            CreatedDate: action.payload.createdDate,
            Description: action.payload.description,
            FlaggedBy: action.payload.flaggedBy,
            TaskId: action.payload.taskId,
            ToDoFlagId: action.payload.toDoFlagId,
            UserId: action.payload.userId,
            title: action.info.title,
          },
        ];
        let updateTaskFlag = (emp.employeeTodos[listIndex].todos[
          taskIndex
        ].flagLog = JSON.stringify(flagLog));
      }
      // let employeeTodo = state.todoEmployees;
      return {
        ...state,
        addTodoFlagLoading: false,
        addTodoFlagSuccess: true,
        addTodoFlagFailure: false,
        addTodoFlagError: null,
      };
    case TODO.ADD_TODO_FLAG_FAILURE:
      return {
        ...state,
        addTodoFlagSuccess: false,
        addTodoFlagLoading: false,
        addTodoFlagFailure: true,
        addTodoFlagError: action.payload,
      };
    case TODO.ADD_TODO_LOG_TIME_REQUEST:
      return {
        ...state,
        addTodoLogTimeLoading: true,
        addTodoLogTimeSuccess: false,
        addTodoLogTimeFailure: false,
        addTodoLogTimeError: null,
      };
    case TODO.ADD_TODO_LOG_TIME_SUCCESS:
      let employeeIndex = state.todoEmployees.findIndex(
        (item) => item.userId === action.info.employeeId
      );
      let listIndex = state.todoEmployees[
        employeeIndex
      ].employeeTodos.findIndex(
        (item) => item.taskCategoryId === action.info.taskCategoryId
      );
      let taskIndex = state.todoEmployees[employeeIndex].employeeTodos[
        listIndex
      ].todos.findIndex((item) => item.taskId === action.info.taskId);
      let userTodo = (state.todoEmployees[employeeIndex].employeeTodos[
        listIndex
      ].todos[taskIndex].totalTimeSpent = action.payload.totalTimeSpent);
      let todoWorkLogList =
        state.todoEmployees[employeeIndex].employeeTodos[listIndex].todos[
          taskIndex
        ].timeWorkLog;
      let obj = {
        TimeLogged: action.payload.timeLogged,
        Description: action.payload.description,
        CreatedDate: action.payload.createdDate,
        TaskWorkLogId: action.payload.taskWorkLogId,
        TaskId: action.payload.taskId,
      };
      let updatedLogs = [];
      if (todoWorkLogList !== null) {
        updatedLogs = JSON.parse(todoWorkLogList);
        updatedLogs.push(obj);
        state.todoEmployees[employeeIndex].employeeTodos[listIndex].todos[
          taskIndex
        ].timeWorkLog = JSON.stringify(updatedLogs);
      } else {
        updatedLogs.push(obj);
        state.todoEmployees[employeeIndex].employeeTodos[listIndex].todos[
          taskIndex
        ].timeWorkLog = JSON.stringify(updatedLogs);
      }

      return {
        ...state,
        addTodoLogTimeLoading: false,
        addTodoLogTimeSuccess: true,
        addTodoLogTimeFailure: false,
        addTodoLogTimeError: null,
      };
    case TODO.ADD_TODO_LOG_TIME_FAILURE:
      return {
        ...state,
        addTodoLogTimeSuccess: false,
        addTodoLogTimeLoading: false,
        addTodoLogTimeFailure: true,
        addTodoLogTimeError: action.payload,
      };
    case TODO.GET_LOGGED_HOUR_GRAPH_DATA_REQUEST:
      return {
        ...state,
        getLoggedHourGraphDataLoading: true,
        getLoggedHourGraphDataSuccess: false,
        getLoggedHourGraphDataFailure: false,
        getLoggedHourGraphDataError: null,
        loggedHourGraphData: null,
      };
    case TODO.GET_LOGGED_HOUR_GRAPH_DATA_SUCCESS:
      return {
        ...state,
        getLoggedHourGraphDataLoading: false,
        getLoggedHourGraphDataSuccess: true,
        getLoggedHourGraphDataFailure: false,
        getLoggedHourGraphDataError: null,
        loggedHourGraphData: action.payload,
      };
    case TODO.GET_LOGGED_HOUR_GRAPH_DATA_FAILURE:
      return {
        ...state,
        getLoggedHourGraphDataLoading: false,
        getLoggedHourGraphDataSuccess: false,
        getLoggedHourGraphDataFailure: true,
        getLoggedHourGraphDataError: action.payload,
        loggedHourGraphData: null,
      };
    case TODO.GET_TASK_HOUR_COMPARISON_BY_EMP_REQUEST:
      return {
        ...state,
        getTaskHourComparisonByEmpLoading: true,
        getTaskHourComparisonByEmpSuccess: false,
        getTaskHourComparisonByEmpFailure: false,
        getTaskHourComparisonByEmpError: null,
        taskHourComparisonByEmp: null,
      };
    case TODO.GET_TASK_HOUR_COMPARISON_BY_EMP_SUCCESS:
      return {
        ...state,
        getTaskHourComparisonByEmpLoading: false,
        getTaskHourComparisonByEmpSuccess: true,
        getTaskHourComparisonByEmpFailure: false,
        getTaskHourComparisonByEmpError: null,
        taskHourComparisonByEmp: action.payload,
      };
    case TODO.GET_TASK_HOUR_COMPARISON_BY_EMP_FAILURE:
      return {
        ...state,
        getTaskHourComparisonByEmpLoading: false,
        getTaskHourComparisonByEmpSuccess: false,
        getTaskHourComparisonByEmpFailure: true,
        getTaskHourComparisonByEmpError: action.payload,
        taskHourComparisonByEmp: null,
      };
    case TODO.GET_EMP_RANKING_ON_LOGGED_HOURS_REQUEST:
      return {
        ...state,
        getEmpRankingOnLoggedHoursLoading: true,
        getEmpRankingOnLoggedHoursSuccess: false,
        getEmpRankingOnLoggedHoursFailure: false,
        getEmpRankingOnLoggedHoursError: null,
        empRankingOnLoggedHours: [],
      };
    case TODO.GET_EMP_RANKING_ON_LOGGED_HOURS_SUCCESS:
      return {
        ...state,
        getEmpRankingOnLoggedHoursLoading: false,
        getEmpRankingOnLoggedHoursSuccess: true,
        getEmpRankingOnLoggedHoursFailure: false,
        getEmpRankingOnLoggedHoursError: null,
        empRankingOnLoggedHours: action.payload,
      };
    case TODO.GET_EMP_RANKING_ON_LOGGED_HOURS_FAILURE:
      return {
        ...state,
        getEmpRankingOnLoggedHoursLoading: false,
        getEmpRankingOnLoggedHoursSuccess: false,
        getEmpRankingOnLoggedHoursFailure: true,
        getEmpRankingOnLoggedHoursError: action.payload,
        empRankingOnLoggedHours: null,
      };
    case TODO.GET_EMP_TASKS_GRAPH_REQUEST:
      return {
        ...state,
        getEmpTasksGraphLoading: true,
        getEmpTasksGraphSuccess: false,
        getEmpTasksGraphFailure: false,
        getEmpTasksGraphError: null,
        empTasksGraph: [],
      };
    case TODO.GET_EMP_TASKS_GRAPH_SUCCESS:
      return {
        ...state,
        getEmpTasksGraphLoading: false,
        getEmpTasksGraphSuccess: true,
        getEmpTasksGraphFailure: false,
        getEmpTasksGraphError: null,
        empTasksGraph: action.payload,
      };
    case TODO.GET_EMP_TASKS_GRAPH_FAILURE:
      return {
        ...state,
        getEmpTasksGraphLoading: false,
        getEmpTasksGraphSuccess: false,
        getEmpTasksGraphFailure: true,
        getEmpTasksGraphError: action.payload,
        empTasksGraph: null,
      };
    case TODO.GET_EMP_TODO_TASK_LIST_REQUEST:
      return {
        ...state,
        getEmpTodoTaskListLoading: true,
        getEmpTodoTaskListSuccess: false,
        getEmpTodoTaskListFailure: false,
        getEmpTodoTaskListError: null,
        empTodoTaskList: [],
      };
    case TODO.GET_EMP_TODO_TASK_LIST_SUCCESS:
      return {
        ...state,
        getEmpTodoTaskListLoading: false,
        getEmpTodoTaskListSuccess: true,
        getEmpTodoTaskListFailure: false,
        getEmpTodoTaskListError: null,
        empTodoTaskList: action.payload,
      };
    case TODO.GET_EMP_TODO_TASK_LIST_FAILURE:
      return {
        ...state,
        getEmpTodoTaskListLoading: false,
        getEmpTodoTaskListSuccess: false,
        getEmpTodoTaskListFailure: true,
        getEmpTodoTaskListError: action.payload,
        empTodoTaskList: null,
      };
    case TODO.GET_USER_TODOS_REQUEST:
      return {
        ...state,
        getUserTodosLoading: true,
        getUserTodosSuccess: false,
        getUserTodosFailure: false,
        getUserTodosError: null,
        userTodosData: [],
      };
    case TODO.GET_USER_TODOS_SUCCESS:
      return {
        ...state,
        getUserTodosLoading: false,
        getUserTodosSuccess: true,
        getUserTodosFailure: false,
        getUserTodosError: null,
        userTodosData: action.payload,
      };
    case TODO.GET_USER_TODOS_FAILURE:
      return {
        ...state,
        getUserTodosLoading: false,
        getUserTodosSuccess: false,
        getUserTodosFailure: true,
        getUserTodosError: action.payload,
        userTodosData: [],
      };
    default:
      return state;
  }
};
